// src/contexts/TermineContext.js
import React, { createContext, useCallback, useContext, useState } from "react";
import { fetchWithRetry } from "../utils/fetchWithRetry";

const TermineContext = createContext();

export const TermineProvider = ({ children }) => {
  const [termine, setTermine] = useState([]);
  const [termineLoading, setTermineLoading] = useState(false);
  const [termineError, setTermineError] = useState(null);

  const fetchTermine = useCallback(async ({ classId, combinationId } = {}) => {
    setTermineLoading(true); setTermineError(null);
    const ac = new AbortController();

    let url = `${process.env.REACT_APP_API_BASE_URL}/items/Termine?fields=*.*`;
    if (classId) {
      url = `${process.env.REACT_APP_API_BASE_URL}/items/Termine?filter[Modul][Klassen][_in]=${classId}&fields=*.*`;
    }
    if (combinationId) {
      url = `${process.env.REACT_APP_API_BASE_URL}/items/Termine?filter[Modul][Klassen][_in]=${combinationId}&fields=*.*`;
    }

    try {
      const res = await fetchWithRetry(
        () => fetch(url, { signal: ac.signal }),
        { retries: 3, baseDelay: 300, signal: ac.signal }
      );
      if (!res.ok) throw new Error(`HTTP: ${res.status}`);
      const data = await res.json();
      setTermine(data?.data ?? []);
    } catch (e) {
      if (!ac.signal.aborted) setTermineError("Ошибка при загрузке Termine!");
    } finally {
      if (!ac.signal.aborted) setTermineLoading(false);
    }
  }, []);

  return (
    <TermineContext.Provider value={{ termine, termineLoading, termineError, fetchTermine }}>
      {children}
    </TermineContext.Provider>
  );
};

export const useTermine = () => useContext(TermineContext);
